import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _247dcb66 = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _1126087e = () => interopDefault(import('../pages/admin-tasks/index.vue' /* webpackChunkName: "pages/admin-tasks/index" */))
const _ee12df98 = () => interopDefault(import('../pages/cases/index.vue' /* webpackChunkName: "pages/cases/index" */))
const _1f747c98 = () => interopDefault(import('../pages/configuracion/index.vue' /* webpackChunkName: "pages/configuracion/index" */))
const _24df51c8 = () => interopDefault(import('../pages/contratos/index.vue' /* webpackChunkName: "pages/contratos/index" */))
const _45870221 = () => interopDefault(import('../pages/editor-plantillas/index.vue' /* webpackChunkName: "pages/editor-plantillas/index" */))
const _ad0dd2f2 = () => interopDefault(import('../pages/editor-plantillas2/index.vue' /* webpackChunkName: "pages/editor-plantillas2/index" */))
const _91eb9f76 = () => interopDefault(import('../pages/equipos/index.vue' /* webpackChunkName: "pages/equipos/index" */))
const _1a9defb2 = () => interopDefault(import('../pages/formularios/index.vue' /* webpackChunkName: "pages/formularios/index" */))
const _63065e38 = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _714d4528 = () => interopDefault(import('../pages/integrantes-equipos/index.vue' /* webpackChunkName: "pages/integrantes-equipos/index" */))
const _13f91cda = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _49eb193e = () => interopDefault(import('../pages/main/index.vue' /* webpackChunkName: "pages/main/index" */))
const _7c8df081 = () => interopDefault(import('../pages/pendings/index.vue' /* webpackChunkName: "pages/pendings/index" */))
const _777a9bec = () => interopDefault(import('../pages/preliquidacion/index.vue' /* webpackChunkName: "pages/preliquidacion/index" */))
const _524f9f52 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _2f61aac1 = () => interopDefault(import('../pages/protocolos/index.vue' /* webpackChunkName: "pages/protocolos/index" */))
const _1dbdf427 = () => interopDefault(import('../pages/reportes/index.vue' /* webpackChunkName: "pages/reportes/index" */))
const _6b8803a0 = () => interopDefault(import('../pages/reports/index.vue' /* webpackChunkName: "pages/reports/index" */))
const _d0ed77e2 = () => interopDefault(import('../pages/reports-v2/index.vue' /* webpackChunkName: "pages/reports-v2/index" */))
const _e4282492 = () => interopDefault(import('../pages/status/index.vue' /* webpackChunkName: "pages/status/index" */))
const _3060ff57 = () => interopDefault(import('../pages/tareas/index.vue' /* webpackChunkName: "pages/tareas/index" */))
const _a1631464 = () => interopDefault(import('../pages/update/index.vue' /* webpackChunkName: "pages/update/index" */))
const _8b051d36 = () => interopDefault(import('../pages/vainilla-apps.vue' /* webpackChunkName: "pages/vainilla-apps" */))
const _97ac3614 = () => interopDefault(import('../pages/acl/registro-entidad.vue' /* webpackChunkName: "pages/acl/registro-entidad" */))
const _181eb871 = () => interopDefault(import('../pages/acl/users.vue' /* webpackChunkName: "pages/acl/users" */))
const _1b98f000 = () => interopDefault(import('../pages/cases/drafts.vue' /* webpackChunkName: "pages/cases/drafts" */))
const _54c9de8c = () => interopDefault(import('../pages/cases/form_templates.vue' /* webpackChunkName: "pages/cases/form_templates" */))
const _f56e36fc = () => interopDefault(import('../pages/cases/new.vue' /* webpackChunkName: "pages/cases/new" */))
const _b4b101ac = () => interopDefault(import('../pages/configuracion/app/index.vue' /* webpackChunkName: "pages/configuracion/app/index" */))
const _23141e55 = () => interopDefault(import('../pages/configuracion/integracion-pos/index.vue' /* webpackChunkName: "pages/configuracion/integracion-pos/index" */))
const _27fe0008 = () => interopDefault(import('../pages/configuracion/integraciones/index.vue' /* webpackChunkName: "pages/configuracion/integraciones/index" */))
const _91820386 = () => interopDefault(import('../pages/configuracion/plantillas/index.vue' /* webpackChunkName: "pages/configuracion/plantillas/index" */))
const _2168cdf0 = () => interopDefault(import('../pages/configuracion/reprocesos/index.vue' /* webpackChunkName: "pages/configuracion/reprocesos/index" */))
const _c2f73ec6 = () => interopDefault(import('../pages/configuracion/sincronizar-resoluciones/index.vue' /* webpackChunkName: "pages/configuracion/sincronizar-resoluciones/index" */))
const _536f3186 = () => interopDefault(import('../pages/editor-plantillas/nuevo.vue' /* webpackChunkName: "pages/editor-plantillas/nuevo" */))
const _18aa170b = () => interopDefault(import('../pages/editor-plantillas/nuevoInicio.vue' /* webpackChunkName: "pages/editor-plantillas/nuevoInicio" */))
const _074820bc = () => interopDefault(import('../pages/editor-plantillas/nuevoPDF.vue' /* webpackChunkName: "pages/editor-plantillas/nuevoPDF" */))
const _913d7428 = () => interopDefault(import('../pages/editor-plantillas2/nuevo.vue' /* webpackChunkName: "pages/editor-plantillas2/nuevo" */))
const _4f78c6f1 = () => interopDefault(import('../pages/editor-plantillas2/nuevoInicio.vue' /* webpackChunkName: "pages/editor-plantillas2/nuevoInicio" */))
const _61482ad4 = () => interopDefault(import('../pages/editor-plantillas2/nuevoPDF.vue' /* webpackChunkName: "pages/editor-plantillas2/nuevoPDF" */))
const _28861f17 = () => interopDefault(import('../pages/formularios/nuevo.vue' /* webpackChunkName: "pages/formularios/nuevo" */))
const _015550de = () => interopDefault(import('../pages/main/funciones.vue' /* webpackChunkName: "pages/main/funciones" */))
const _51470309 = () => interopDefault(import('../pages/plantillas-correo/nuevo.vue' /* webpackChunkName: "pages/plantillas-correo/nuevo" */))
const _3cbbdcf6 = () => interopDefault(import('../pages/procesos/depreciacion/index.vue' /* webpackChunkName: "pages/procesos/depreciacion/index" */))
const _3f3e85b3 = () => interopDefault(import('../pages/protocolos/tareas.vue' /* webpackChunkName: "pages/protocolos/tareas" */))
const _f85199a8 = () => interopDefault(import('../pages/reports/table.vue' /* webpackChunkName: "pages/reports/table" */))
const _136841de = () => interopDefault(import('../pages/templates/new_template.vue' /* webpackChunkName: "pages/templates/new_template" */))
const _48bdb97f = () => interopDefault(import('../pages/turnos/actividades.vue' /* webpackChunkName: "pages/turnos/actividades" */))
const _fa9d19fa = () => interopDefault(import('../pages/turnos/crear-turnos.vue' /* webpackChunkName: "pages/turnos/crear-turnos" */))
const _3945ddad = () => interopDefault(import('../pages/turnos/prueba.vue' /* webpackChunkName: "pages/turnos/prueba" */))
const _71c43367 = () => interopDefault(import('../pages/turnos/ver-turnos.vue' /* webpackChunkName: "pages/turnos/ver-turnos" */))
const _c9c054d2 = () => interopDefault(import('../pages/unimarka/facturas/index.vue' /* webpackChunkName: "pages/unimarka/facturas/index" */))
const _22832302 = () => interopDefault(import('../pages/unimarka/notas/index.vue' /* webpackChunkName: "pages/unimarka/notas/index" */))
const _b84d4964 = () => interopDefault(import('../pages/user/create-account.vue' /* webpackChunkName: "pages/user/create-account" */))
const _0adee75e = () => interopDefault(import('../pages/user/recovery-password.vue' /* webpackChunkName: "pages/user/recovery-password" */))
const _476aaa26 = () => interopDefault(import('../pages/user/request-account.vue' /* webpackChunkName: "pages/user/request-account" */))
const _260b62cc = () => interopDefault(import('../pages/vainilla/registrar-proyecto.vue' /* webpackChunkName: "pages/vainilla/registrar-proyecto" */))
const _02016be5 = () => interopDefault(import('../pages/configuracion/plantillas/_id.vue' /* webpackChunkName: "pages/configuracion/plantillas/_id" */))
const _47740f8a = () => interopDefault(import('../pages/public/cases/_id.vue' /* webpackChunkName: "pages/public/cases/_id" */))
const _0d32cc7e = () => interopDefault(import('../pages/vainilla/confirmar-proyecto/_id.vue' /* webpackChunkName: "pages/vainilla/confirmar-proyecto/_id" */))
const _71930f9c = () => interopDefault(import('../pages/cases/_id.vue' /* webpackChunkName: "pages/cases/_id" */))
const _2bd36bf1 = () => interopDefault(import('../pages/change-password/_id.vue' /* webpackChunkName: "pages/change-password/_id" */))
const _043184fc = () => interopDefault(import('../pages/crear-entidad/_id.vue' /* webpackChunkName: "pages/crear-entidad/_id" */))
const _241e0b90 = () => interopDefault(import('../pages/editor-plantillas/_id_plantilla/index.vue' /* webpackChunkName: "pages/editor-plantillas/_id_plantilla/index" */))
const _61596761 = () => interopDefault(import('../pages/formularios/_id_plantilla/index.vue' /* webpackChunkName: "pages/formularios/_id_plantilla/index" */))
const _30fc8dc2 = () => interopDefault(import('../pages/login/_id.vue' /* webpackChunkName: "pages/login/_id" */))
const _796b59b4 = () => interopDefault(import('../pages/main/_id.vue' /* webpackChunkName: "pages/main/_id" */))
const _d45aba72 = () => interopDefault(import('../pages/reports-v2/_slug.vue' /* webpackChunkName: "pages/reports-v2/_slug" */))
const _63dab49e = () => interopDefault(import('../pages/reports/_report.vue' /* webpackChunkName: "pages/reports/_report" */))
const _6e04eb7f = () => interopDefault(import('../pages/tareas/_id.vue' /* webpackChunkName: "pages/tareas/_id" */))
const _7b6fd9d2 = () => interopDefault(import('../pages/validacion/_id.vue' /* webpackChunkName: "pages/validacion/_id" */))
const _6c2f5c42 = () => interopDefault(import('../pages/editor-plantillas/_id_plantilla/creacion.vue' /* webpackChunkName: "pages/editor-plantillas/_id_plantilla/creacion" */))
const _0ad122d1 = () => interopDefault(import('../pages/formularios/_id_plantilla/creacion.vue' /* webpackChunkName: "pages/formularios/_id_plantilla/creacion" */))
const _4caf7550 = () => interopDefault(import('../pages/editor-plantillas/_id_plantilla/edicion/_id.vue' /* webpackChunkName: "pages/editor-plantillas/_id_plantilla/edicion/_id" */))
const _05a9c069 = () => interopDefault(import('../pages/formularios/_id_plantilla/edicion/_id.vue' /* webpackChunkName: "pages/formularios/_id_plantilla/edicion/_id" */))
const _349d6ba2 = () => interopDefault(import('../pages/publico/_entidad/_protocolo.vue' /* webpackChunkName: "pages/publico/_entidad/_protocolo" */))
const _1fee4080 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _247dcb66,
    name: "404"
  }, {
    path: "/admin-tasks",
    component: _1126087e,
    name: "admin-tasks"
  }, {
    path: "/cases",
    component: _ee12df98,
    name: "cases"
  }, {
    path: "/configuracion",
    component: _1f747c98,
    name: "configuracion"
  }, {
    path: "/contratos",
    component: _24df51c8,
    name: "contratos"
  }, {
    path: "/editor-plantillas",
    component: _45870221,
    name: "editor-plantillas"
  }, {
    path: "/editor-plantillas2",
    component: _ad0dd2f2,
    name: "editor-plantillas2"
  }, {
    path: "/equipos",
    component: _91eb9f76,
    name: "equipos"
  }, {
    path: "/formularios",
    component: _1a9defb2,
    name: "formularios"
  }, {
    path: "/home",
    component: _63065e38,
    name: "home"
  }, {
    path: "/integrantes-equipos",
    component: _714d4528,
    name: "integrantes-equipos"
  }, {
    path: "/login",
    component: _13f91cda,
    name: "login"
  }, {
    path: "/main",
    component: _49eb193e,
    name: "main"
  }, {
    path: "/pendings",
    component: _7c8df081,
    name: "pendings"
  }, {
    path: "/preliquidacion",
    component: _777a9bec,
    name: "preliquidacion"
  }, {
    path: "/profile",
    component: _524f9f52,
    name: "profile"
  }, {
    path: "/protocolos",
    component: _2f61aac1,
    name: "protocolos"
  }, {
    path: "/reportes",
    component: _1dbdf427,
    name: "reportes"
  }, {
    path: "/reports",
    component: _6b8803a0,
    name: "reports"
  }, {
    path: "/reports-v2",
    component: _d0ed77e2,
    name: "reports-v2"
  }, {
    path: "/status",
    component: _e4282492,
    name: "status"
  }, {
    path: "/tareas",
    component: _3060ff57,
    name: "tareas"
  }, {
    path: "/update",
    component: _a1631464,
    name: "update"
  }, {
    path: "/vainilla-apps",
    component: _8b051d36,
    name: "vainilla-apps"
  }, {
    path: "/acl/registro-entidad",
    component: _97ac3614,
    name: "acl-registro-entidad"
  }, {
    path: "/acl/users",
    component: _181eb871,
    name: "acl-users"
  }, {
    path: "/cases/drafts",
    component: _1b98f000,
    name: "cases-drafts"
  }, {
    path: "/cases/form_templates",
    component: _54c9de8c,
    name: "cases-form_templates"
  }, {
    path: "/cases/new",
    component: _f56e36fc,
    name: "cases-new"
  }, {
    path: "/configuracion/app",
    component: _b4b101ac,
    name: "configuracion-app"
  }, {
    path: "/configuracion/integracion-pos",
    component: _23141e55,
    name: "configuracion-integracion-pos"
  }, {
    path: "/configuracion/integraciones",
    component: _27fe0008,
    name: "configuracion-integraciones"
  }, {
    path: "/configuracion/plantillas",
    component: _91820386,
    name: "configuracion-plantillas"
  }, {
    path: "/configuracion/reprocesos",
    component: _2168cdf0,
    name: "configuracion-reprocesos"
  }, {
    path: "/configuracion/sincronizar-resoluciones",
    component: _c2f73ec6,
    name: "configuracion-sincronizar-resoluciones"
  }, {
    path: "/editor-plantillas/nuevo",
    component: _536f3186,
    name: "editor-plantillas-nuevo"
  }, {
    path: "/editor-plantillas/nuevoInicio",
    component: _18aa170b,
    name: "editor-plantillas-nuevoInicio"
  }, {
    path: "/editor-plantillas/nuevoPDF",
    component: _074820bc,
    name: "editor-plantillas-nuevoPDF"
  }, {
    path: "/editor-plantillas2/nuevo",
    component: _913d7428,
    name: "editor-plantillas2-nuevo"
  }, {
    path: "/editor-plantillas2/nuevoInicio",
    component: _4f78c6f1,
    name: "editor-plantillas2-nuevoInicio"
  }, {
    path: "/editor-plantillas2/nuevoPDF",
    component: _61482ad4,
    name: "editor-plantillas2-nuevoPDF"
  }, {
    path: "/formularios/nuevo",
    component: _28861f17,
    name: "formularios-nuevo"
  }, {
    path: "/main/funciones",
    component: _015550de,
    name: "main-funciones"
  }, {
    path: "/plantillas-correo/nuevo",
    component: _51470309,
    name: "plantillas-correo-nuevo"
  }, {
    path: "/procesos/depreciacion",
    component: _3cbbdcf6,
    name: "procesos-depreciacion"
  }, {
    path: "/protocolos/tareas",
    component: _3f3e85b3,
    name: "protocolos-tareas"
  }, {
    path: "/reports/table",
    component: _f85199a8,
    name: "reports-table"
  }, {
    path: "/templates/new_template",
    component: _136841de,
    name: "templates-new_template"
  }, {
    path: "/turnos/actividades",
    component: _48bdb97f,
    name: "turnos-actividades"
  }, {
    path: "/turnos/crear-turnos",
    component: _fa9d19fa,
    name: "turnos-crear-turnos"
  }, {
    path: "/turnos/prueba",
    component: _3945ddad,
    name: "turnos-prueba"
  }, {
    path: "/turnos/ver-turnos",
    component: _71c43367,
    name: "turnos-ver-turnos"
  }, {
    path: "/unimarka/facturas",
    component: _c9c054d2,
    name: "unimarka-facturas"
  }, {
    path: "/unimarka/notas",
    component: _22832302,
    name: "unimarka-notas"
  }, {
    path: "/user/create-account",
    component: _b84d4964,
    name: "user-create-account"
  }, {
    path: "/user/recovery-password",
    component: _0adee75e,
    name: "user-recovery-password"
  }, {
    path: "/user/request-account",
    component: _476aaa26,
    name: "user-request-account"
  }, {
    path: "/vainilla/registrar-proyecto",
    component: _260b62cc,
    name: "vainilla-registrar-proyecto"
  }, {
    path: "/configuracion/plantillas/:id",
    component: _02016be5,
    name: "configuracion-plantillas-id"
  }, {
    path: "/public/cases/:id?",
    component: _47740f8a,
    name: "public-cases-id"
  }, {
    path: "/vainilla/confirmar-proyecto/:id?",
    component: _0d32cc7e,
    name: "vainilla-confirmar-proyecto-id"
  }, {
    path: "/cases/:id",
    component: _71930f9c,
    name: "cases-id"
  }, {
    path: "/change-password/:id?",
    component: _2bd36bf1,
    name: "change-password-id"
  }, {
    path: "/crear-entidad/:id?",
    component: _043184fc,
    name: "crear-entidad-id"
  }, {
    path: "/editor-plantillas/:id_plantilla",
    component: _241e0b90,
    name: "editor-plantillas-id_plantilla"
  }, {
    path: "/formularios/:id_plantilla",
    component: _61596761,
    name: "formularios-id_plantilla"
  }, {
    path: "/login/:id",
    component: _30fc8dc2,
    name: "login-id"
  }, {
    path: "/main/:id",
    component: _796b59b4,
    name: "main-id"
  }, {
    path: "/reports-v2/:slug",
    component: _d45aba72,
    name: "reports-v2-slug"
  }, {
    path: "/reports/:report",
    component: _63dab49e,
    name: "reports-report"
  }, {
    path: "/tareas/:id",
    component: _6e04eb7f,
    name: "tareas-id"
  }, {
    path: "/validacion/:id?",
    component: _7b6fd9d2,
    name: "validacion-id"
  }, {
    path: "/editor-plantillas/:id_plantilla?/creacion",
    component: _6c2f5c42,
    name: "editor-plantillas-id_plantilla-creacion"
  }, {
    path: "/formularios/:id_plantilla/creacion",
    component: _0ad122d1,
    name: "formularios-id_plantilla-creacion"
  }, {
    path: "/editor-plantillas/:id_plantilla?/edicion/:id",
    component: _4caf7550,
    name: "editor-plantillas-id_plantilla-edicion-id"
  }, {
    path: "/formularios/:id_plantilla/edicion/:id?",
    component: _05a9c069,
    name: "formularios-id_plantilla-edicion-id"
  }, {
    path: "/publico/:entidad?/:protocolo?",
    component: _349d6ba2,
    name: "publico-entidad-protocolo"
  }, {
    path: "/",
    component: _1fee4080,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
